import styled from "styled-components";
import { COLORS } from "utils/constants";

export const MemberList = styled.div`
  margin-top: 24px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;

export const ErrorText = styled.p`
  font-size: 14px;
  color: ${COLORS.RED};
  text-align: center;
  margin-top: 40px;
`;
